import React, { createContext, useState, useContext, useEffect } from "react";

const ZoomContext = createContext();

export const ZoomProvider = ({ children }) => {
  const [zoomLevel, setZoomLevel] = useState(() => {
    const stored = sessionStorage.getItem("imageZoomLevel");
    return stored ? parseFloat(stored) : 1.5;
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--image-zoom-level', zoomLevel);
    sessionStorage.setItem("imageZoomLevel", zoomLevel);
  }, [zoomLevel]);

  return (
    <ZoomContext.Provider value={{ zoomLevel, setZoomLevel }}>
      {children}
    </ZoomContext.Provider>
  );
};

export const useZoom = () => useContext(ZoomContext);
